<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Cupons | Criar" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-coupon
            v-model="model"
            :readonly="false"
            :editing="false"
            @submit="submit"
          />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import CouponService from '@/services/CouponService'
import FormCoupon from './form-coupon.vue'
import type Coupon from '@/types/Coupon'
import type User from '@/types/User'
import type TicketType from '@/types/TicketType'
import { useLoader } from '@/stores/loader'
import { useRouter } from 'vue-router'
import { useSnackBar } from '@/stores/snackbar'
import { DateTime } from 'luxon'

const loader = useLoader()
const router = useRouter()
const snackbar = useSnackBar()

const service = new CouponService()

const model = ref<Coupon>({
  code: '',
  value: 10,
  method: 'percentage' as 'absolute' | 'percentage',
  max_items: 1,
  max_uses: 1,
  cumulative: false,
  expires_at: DateTime.now()
    .plus({ days: 7 })
    .set({ hour: 0, minute: 0, second: 0 })
    .toFormat('yyyy-MM-dd HH:mm:ss'),
  users: [] as User[],
  ticket_types: [] as TicketType[],
} as unknown as Coupon)

async function submit(model: Coupon, users: { assigned: string[], unassigned: string[] }) {
  try {
    loader.increment()

    await service.store(model, users)

    snackbar.show('Cupom criado com sucesso', 'success')

    router.push({ name: 'list-coupons' })
  } catch (error) {
    snackbar.show(' Não foi possível criar o cupom', 'error')

    throw error
  } finally {
    loader.decrement()
  }
}
</script>
